import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ShoppingBag } from "lucide-react";
import { LOGO_URL } from "@/constants/brand";
import { useCheckout } from "@/hooks/useCheckout";

const NAV = [
    { label: "Shop", href: "/shop", route: true },
    { label: "Hair Guide", href: "/hair-care-guide", route: true },
    { label: "Blog", href: "/blog", route: true },
    { label: "Track Order", href: "/track-order", route: true },
    { label: "Benefits", href: "#benefits" },
    { label: "Results", href: "#results" },
    { label: "Reviews", href: "#reviews" },
    { label: "FAQs", href: "#faqs" },
];

export default function Header() {
    const [open, setOpen] = useState(false);
    const { product, openCheckout } = useCheckout();

    const handleOrderNow = (e) => {
        e.preventDefault();
        setOpen(false);
        if (product) {
            openCheckout();
        } else {
            const el =
                document.getElementById("checkout") ||
                document.getElementById("shop");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-40 bg-cream/85 backdrop-blur-md border-b border-forest-100"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-20 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="logo-link"
                    className="flex items-center gap-3"
                >
                    <img
                        src={LOGO_URL}
                        alt="Resham Drops"
                        className="h-10 sm:h-12 w-10 sm:w-12 rounded-full object-cover border-2 border-gold-500 shadow-sm"
                    />
                    <div className="leading-tight">
                        <span className="font-serif font-bold text-forest-800 text-lg sm:text-xl block">
                            Resham Drops
                        </span>
                        <span className="text-[10px] uppercase tracking-[0.2em] text-gold-600 font-semibold hidden sm:block">
                            Botanical Hair Science
                        </span>
                    </div>
                </a>

                <nav className="hidden lg:flex items-center gap-8">
                    {NAV.map((item) =>
                        item.route ? (
                            <Link
                                key={item.href}
                                to={item.href}
                                data-testid={`nav-${item.label.toLowerCase()}`}
                                className="text-sm font-semibold text-forest-800 hover:text-gold-600 transition-colors"
                            >
                                {item.label}
                            </Link>
                        ) : (
                            <a
                                key={item.href}
                                href={item.href}
                                data-testid={`nav-${item.label.toLowerCase()}`}
                                className="text-sm font-semibold text-forest-800 hover:text-gold-600 transition-colors"
                            >
                                {item.label}
                            </a>
                        ),
                    )}
                </nav>

                <div className="flex items-center gap-2 sm:gap-3">
                    <a
                        href="#checkout"
                        onClick={handleOrderNow}
                        data-testid="header-order-btn"
                        className="hidden sm:flex items-center gap-2 bg-forest-800 hover:bg-forest-900 text-gold-400 border border-gold-500/40 font-bold text-xs sm:text-sm px-4 py-2.5 rounded-full transition-all shadow-sm hover:shadow-md"
                    >
                        <ShoppingBag className="w-4 h-4" />
                        Order Now
                    </a>
                    <button
                        onClick={() => setOpen((v) => !v)}
                        data-testid="mobile-menu-toggle"
                        className="lg:hidden w-10 h-10 rounded-full bg-forest-800 text-gold-400 flex items-center justify-center"
                        aria-label="Menu"
                    >
                        {open ? (
                            <X className="w-5 h-5" />
                        ) : (
                            <Menu className="w-5 h-5" />
                        )}
                    </button>
                </div>
            </div>

            {open && (
                <div
                    data-testid="mobile-menu"
                    className="lg:hidden border-t border-forest-100 bg-cream"
                >
                    <div className="px-4 py-4 flex flex-col gap-1">
                        {NAV.map((item) =>
                            item.route ? (
                                <Link
                                    key={item.href}
                                    to={item.href}
                                    onClick={() => setOpen(false)}
                                    data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                                    className="px-3 py-3 rounded-xl text-sm font-semibold text-forest-800 hover:bg-forest-50"
                                >
                                    {item.label}
                                </Link>
                            ) : (
                                <a
                                    key={item.href}
                                    href={item.href}
                                    onClick={() => setOpen(false)}
                                    className="px-3 py-3 rounded-xl text-sm font-semibold text-forest-800 hover:bg-forest-50"
                                >
                                    {item.label}
                                </a>
                            ),
                        )}
                        <a
                            href="#checkout"
                            onClick={handleOrderNow}
                            className="mt-2 flex items-center justify-center gap-2 bg-forest-800 text-gold-400 font-bold text-sm px-4 py-3 rounded-xl border border-gold-500/40"
                        >
                            <ShoppingBag className="w-4 h-4" /> Order Now
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
